import { useState, useEffect, useContext } from "react";
import styles from "./styles.module.css";
import { MdChevronRight } from "react-icons/md";
import { AppValue } from "../contexts/app";
import Dynamic from "./dynamic";

export default function Pages({ value, onChange }) {
  const [_value, setValue] = useState({ page: "", value: null });
  const [selected, setSelected] = useState("");
  const [open, setOpen] = useState(false);
  const { pages } = useContext(AppValue);
  const [_pages, setPages] = useState([]);

  const onSelect = (page) => {
    const value = { ..._value };
    value.page = page.id;
    onChange(value);
    setOpen(false);
  };

  const handleDynamicChange = (dv) => {
    const value = { ..._value };
    value.value = dv;
    onChange(value);
  };

  useEffect(() => {
    const _pages = [];

    const addPage = (pageId, parents) => {
      const page = pages.find((x) => x.id === pageId);
      if (page) {
        _pages.push({ ...page, parents });
        page.subpages.forEach((id) => {
          addPage(id, [...parents, page.name]);
        });
      }
    };
    pages
      .filter((x) => x.topLevel)
      .sort((x, y) => (x.order > y.order ? 1 : -1))
      .forEach((p) => {
        _pages.push({ ...p, parents: [] });
        p.subpages.forEach((id, i) => {
          addPage(id, [p.name]);
        });
      });
    setPages(_pages);
  }, [pages]);

  useEffect(() => {
    if (value && value.page) {
      const page = pages.find((x) => x.id === value.page);
      if (page) setSelected(page);
      setValue(value);
    }
  }, [value]);

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <div
        onClick={() => setOpen(true)}
        style={{ minHeight: 33 }}
        className="input"
      >
        {selected.name}
      </div>
      {selected.dynamic && (
        <DynamicPage
          value={_value.value}
          onChange={handleDynamicChange}
          schema={selected.dynamic}
        />
      )}
      {open && (
        <div
          style={{
            position: "absolute",
            top: 40,
            width: 300,
            height: 300,
            backgroundColor: "white",
            boxShadow: "var(--shadow)",
            borderRadius: 8,
            overflowY: "auto",
          }}
        >
          {_pages.map((p) => {
            return (
              <PageCard
                onClick={onSelect}
                selected={_value.page === p.id}
                page={p}
                key={p.id}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}

const PageCard = ({ page, selected, onClick }) => {
  return (
    <div
      className={
        selected ? `${styles.pageSelect} ${styles.selected}` : styles.pageSelect
      }
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => onClick(page)}
    >
      {page.parents.map((p) => {
        return <MdChevronRight />;
      })}
      <div>{page.name}</div>
    </div>
  );
};

const DynamicPage = ({ schema, value, onChange }) => {
  const handleChange = (v) => {
    onChange(v);
  };
  return (
    <div className={styles.dynamicPageEditor}>
      <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>
        Value
      </div>
      <Dynamic
        value={value}
        onChange={handleChange}
        params={{ type: schema.type, list: false }}
        sources={[]}
      />
    </div>
  );
};
